import React from "react";
import { fetch as router } from "helpers/router";
import ChuffedLogo from "components/ChuffedLogo";
import LanguageProvider from "components/LanguageProvider/LanguageProvider";
import useGetTranslationFiles from "components/LanguageProvider/utils/getTranslationFiles";
import useAuthViewer from "hooks/useAuthViewer";
import DashboardNav from "./templates/DashboardNav";
import useCookieConsent from "../../hooks/useCookieConsent";
import ClientNav from "./templates/ClientNav";
import useClearSensitiveDataFromStorage from "../../hooks/useClearSensitiveDataFromStorage";

const renderNavLinkItem = (label, url, onClick = false) => (
  <li className="navigation__list-item">
    <a
      className="navigation__item-link"
      data-test="navigation__item-link"
      href={url}
      onClick={onClick || undefined}
    >
      {label}
    </a>
  </li>
);

const renderSection = (viewer) => {
  const isLoggedIn = viewer !== null;
  const isDashboard = ["dashboard", "edit"].includes(window.location.pathname.split("/")[1].toLowerCase());

  if (isLoggedIn && isDashboard) {
    return (
      <DashboardNav
        me={viewer}
        renderNavLinkItem={renderNavLinkItem}
        router={router}
      />
    );
  }
  return (
    <ClientNav
      me={viewer}
      router={router}
      isLoggedIn={isLoggedIn}
    />
  );
};

export const Navigation = () => {
  useCookieConsent();
  useClearSensitiveDataFromStorage();
  const { viewer } = useAuthViewer();
  const { translations, filesLoading } = useGetTranslationFiles();

  if (filesLoading) {
    return null;
  }

  return (
    <div className="header__container" data-testid="header-container">
      <div className="header__section --has-items">
        <a className="header__logo-link" href="/" data-test="header-logo__link">
          <ChuffedLogo />
        </a>
      </div>
      <LanguageProvider translations={translations}>
        {renderSection(viewer)}
      </LanguageProvider>
    </div>
  );
};

export default Navigation;
